const translations = {
  "en": {
    "Upload": "Upload"
  },
  "zh-tw": {
    "Upload": "上傳"
  }
};

export default translations;
